import { InfoBox, Link, Typography } from "@cappelendamm/design-system/react";
import NextLink from "next/link";
import { PiWarningCircle } from "react-icons/pi";

export const DigitalServiceLoginRequiredInfoBox = () => {
  return (
    <InfoBox className="flex w-full items-start gap-2">
      <PiWarningCircle size={32} className="text-lg" />
      <Typography variant="body-sm">
        Du må{" "}
        <Link
          variant="inline"
          as={NextLink}
          href="/login"
          className="text-black"
        >
          logge inn
        </Link>{" "}
        for å kjøpe digitale læremidler.
      </Typography>
    </InfoBox>
  );
};
